import angular from 'angular';

import tszToastService from './tsz-toast.service';

const tszToastModule = angular.module('tsz.components.tszToast', [])
  .service('$tszToast', tszToastService);

export default tszToastModule;



// WEBPACK FOOTER //
// ./src/components/tsz-toast/tsz-toast.module.js